import { Component, ReactNode, ErrorInfo } from 'react';

interface State { crashed: boolean }

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { crashed: false };

  static getDerivedStateFromError(): State {
    return { crashed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[AppErrorBoundary]', error, info);
  }

  render() {
    if (this.state.crashed) {
      return (
        <main role="alert" className="flex min-h-screen items-center justify-center p-8">
          <div className="text-center">
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">Something went wrong</h1>
            <p className="text-gray-500 mb-6">An unexpected error occurred. The team has been notified.</p>
            <button
              onClick={() => this.setState({ crashed: false })}
              className="rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
            >
              Try again
            </button>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
